export type UploadVisitType = 'REGULAR' | 'UNSCHEDULED' | 'EARLY TERMINATED';

export enum ReadingStatus {
  READING_PENDING = 'READING_PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  // not supported
  CREATED = 'CREATED',
  TERMINATED = 'TERMINATED',
  FAILED = 'FAILED',
  // end not supported
}

export type Asignee = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
};

export type Reading = {
  id: string;
  createdDate: string;
  readingCode: string;
  assigneeId: string;
  assigneeName: string;
  assignee: Asignee;
  patientId: string;
  patientCode: string;
  visitId: string;
  visitName: string;
  visitType: UploadVisitType;
  visitEarlyTermination: boolean;
  scoringFormCode: string;
  scoringFormName: string;
  startReadingTime: string;
  finishReadingTime: string;
  status: ReadingStatus;
  grouped: boolean;
  viewerEmbedded: boolean;
  children?: Reading[];
};

export type ReaderTasksFilters = {
  statuses: ReadingStatus[];
  search: string;
  sort: string;
};

export enum ReaderTasksRequestStatus {
  OPEN = 'OPEN',
  DONE = 'DONE',
}

export type ReaderAllTasksFilters = {
  search: string;
  requestTaskStatus: ReaderTasksRequestStatus;
  viewerEmbedded?: boolean;
};
